import { FusionAuthClient } from '@fusionauth/typescript-client'

export const FUSIONAUTH_APIKEY = process.env.FUSIONAUTH_APIKEY
export const FUSIONAUTH_HOST = process.env.FUSIONAUTH_HOST
export const FUSIONAUTH_TENANTID = process.env.FUSIONAUTH_TENANTID
export const FUSIONAUTH_ABLE_APPLICATION_ID = process.env.FUSIONAUTH_ABLE_APPLICATION_ID

export const fusionClient = new FusionAuthClient(
  '' + FUSIONAUTH_APIKEY,
  '' + FUSIONAUTH_HOST,
  '' + FUSIONAUTH_TENANTID
)
